<router-link class="text-gray-500 text-base transition-all duration-200 hover:text-gray-900" to="/">{{ state.company?.name }}</router-link>